document.addEventListener('DOMContentLoaded', function () {
  var obs = new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      if (e.isIntersecting) { e.target.classList.add('vu'); obs.unobserve(e.target); }
    });
  }, { threshold: 0.1 });
  document.querySelectorAll('.reveal').forEach(function (el) { obs.observe(el); });

  document.querySelectorAll('[data-pointures]').forEach(function (groupe) {
    var form = groupe.closest('form');
    var champ = form ? form.querySelector('[name="id"]') : null;
    groupe.querySelectorAll('.pp-pointure').forEach(function (b) {
      b.addEventListener('click', function () {
        groupe.querySelectorAll('.pp-pointure').forEach(function (x) { x.setAttribute('aria-pressed', 'false'); });
        b.setAttribute('aria-pressed', 'true');
        if (champ) champ.value = b.dataset.variant;
      });
    });
    var premier = groupe.querySelector('.pp-pointure:not([disabled])');
    if (premier) premier.click();
  });
});
